export default __webpack_public_path__ + "static/media/Merge2.3fec4470.png";